import React from 'react';
import ReactDOM from 'react-dom';
import { observable, action } from 'mobx';
import { enableLogging } from 'mobx-logger';
import { create, persist } from 'mobx-persist'
import './index.css';
import createBrowserHistory from 'history/createBrowserHistory';
import { Provider } from 'mobx-react';
import { RouterStore, syncHistoryWithStore } from 'mobx-react-router';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { LocaleProvider, message } from 'antd';
import viVN from 'antd/lib/locale-provider/vi_VN';
import moment from 'moment';
import { List } from 'immutable';
import axios from 'axios';
const google = window.google;
const API_BASE_URL = 'https://api.123xe.vn/v2/';


// mobx-react-router, react-router-v4
const browserHistory = createBrowserHistory();
const routingStore = new RouterStore();

const hydrate = create();

class userState {
  @persist('object') @observable userInfo = { 
    'avatar': '',
    'creation_time': 0,
    'dplname': '',
    'email': '',
    'id': 0,
    'modification_time': 0,
    'phone': '',
    'sessionkey': '',
    'status': 0
  };
  @observable step = 1;

  @action setUserState(nameState, value){
    if(nameState === 'userInfo') {
      this.userInfo = value;
    }
    if(nameState === 'step') {
      this.step = value;
    }
  }
  @action nextStep() {
    if(this.step < 4)
      this.step++;
  }
 @action preStep() {
   if(this.step > 1)
    this.step--;
 }
  @action getUserInfo(phone, accessToken, sessionkey, appState){
    console.log('appState', appState);
    const url = `${API_BASE_URL}mobileweb/verify/${phone}`
    console.log('url',url);
    axios({
      url:url,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
         Accept: 'application/json',
         Aver: '2.0.0',
         Accesstoken: accessToken,
         Sessionkey: sessionkey,
      },
  
    }).then(this.checkStatus)
      .then((response) => {
        if(response.status === 200){
          if(response.data.error.code === 200){
            const tmp = appState.checkData[0].split('_');
            const fare = appState.serviceGroup[tmp[0]].fare_profile_lines[tmp[1]];
            this.userInfo = response.data.data.user_info;
            const sessionkey = response.data.data.user_info.sessionkey
            const distance = appState.distance;
            const dropoff_time = {
              'end_time':appState.time + appState.duration*60,
              'start_time':appState.time - 1800 + appState.duration*60,
              };
            const fareid = fare.fpid; 
            const start = {
              'address':appState.start.address,
              'area':'',
              'compact_address':'',
              'lat':appState.start.lat,
              'lng':appState.start.lng
              };
              const from_area = fare.pickup_id;
              const isReturn = false;
              const is_sharing = false;
              const load = 1;
              const note = '';
              const operator_id = 0;
              const pickup_time =  {
                'end_time':appState.time ,
                'start_time':appState.time - 1800,
                };
                const price_range = {
                  'higher_cost':appState.price,
                  'lower_cost':appState.price
                  };
                const return_distance = 0;
                const return_range = {
                  'higher_cost':0,
                  'lower_cost':0
                  };
                const return_rate = 0;
                const return_time = {
                  'end_time':0,
                  'start_time':0
                  };
                const route = [{
                  'arrive_time':{
                  'end_time':0,
                  'start_time':0
                  },
                  'location':{
                  'address':appState.start.address,
                  'area':'',
                  'compact_address':'',
                  'lat':appState.start.lat,
                  'lng':appState.start.lng
                  },
                  'request_id':0,
                  'stop_type':1
                  },{
                    'arrive_time':{
                    'end_time':0,
                    'start_time':0
                    },
                    'location':{
                    'address':appState.end.address,
                    'area':'',
                    'compact_address':'',
                    'lat':appState.end.lat,
                    'lng':appState.end.lng
                    },
                    'request_id':0,
                    'stop_type':2
                    }];
                    const  service_group_id = fare.service_group_id;
                    const status = 0;
                    const end = {
                      'address':appState.end.address,
                      'area':'',
                      'compact_address':'',
                      'lat':appState.end.lat,
                      'lng':appState.end.lng
                      };
                    const to_area = fare.dropoff_id;
                    const vehicle_capacity = fare.vehicle_capacity;
                    const vehicle_quality = fare.vehicle_class;
                    const vehicle_type = fare.vehicle_type;
            this.bookCar(sessionkey, distance, dropoff_time, fareid, start, from_area, isReturn, is_sharing, load, note, operator_id, pickup_time, price_range, return_distance, return_range, return_rate, return_time, route, service_group_id, status, end, to_area, vehicle_capacity, vehicle_quality, vehicle_type);
          } 
          else{
            message.error(`Xác thực không thành công, lỗi :${response.data.error.message}`);
          }
        }
        console.log('response', response);
        return response;
      })
      .catch((error) => ({ error }));
  }

  @action bookCar(sessionkey, distance, dropoff_time, fareid, start, from_area, isReturn, is_sharing, load, note, operator_id, pickup_time, price_range, return_distance, return_range, return_rate, return_time, route, service_group_id, status, end, to_area, vehicle_capacity, vehicle_quality, vehicle_type){
    const url = `${API_BASE_URL}passenger/bookings`
    console.log('url',url);
    axios({
      url:url,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
         Accept: 'application/json',
         Aver: '2.0.2',
         Ctype: '0',
         Sessionkey: sessionkey,
      },
      data: JSON.stringify({
        distance, dropoff_time, fareid, 'from':start, from_area, isReturn, is_sharing, load, note, operator_id, pickup_time, price_range, return_distance, return_range, return_rate, return_time, route, service_group_id, status, 'to':end, to_area, vehicle_capacity, vehicle_quality, vehicle_type
      }),
    }).then(this.checkStatus)
      .then((response) => {
        if(response.status === 200){
          if(response.data.error.code === 200){
            this.nextStep();
            
          } else{
            message.error(`Đặt xe không thành công, lỗi :${response.data.error.message}`);            
          }
          // this.userInfo = response.data.data.user_info;
        }
        console.log('response', response);
        return response;
      })
      .catch((error) => ({ error }));
  }
}

class appState {
  
  @persist @observable count = 0
  @persist @observable phone = '';
  @persist @observable name = '';
  @persist('list')   @observable  checkData = [];
  @persist('object') @observable start = { address: '', lat: 0, lng:0  };
  @persist('object') @observable end = { address: '', lat: 0, lng:0  };  
  @persist @observable time = moment().unix() + 60*5;
  @persist @observable duration = 0;
  @persist @observable distance = 0;
  @persist @observable price = 0;
  @persist @observable accessToken = '';
  @persist('list')   @observable serviceGroup = [];
  

  checkStatus = response => {
    if (response.status >= 200 && response.status < 300) {
      return response;
    }
    const error = new Error(response.statusText);
    error.response = response;
    throw error;
  };

  @action removeData(data) {
    console.log('removeData');
    this.count = 0;
    this.phone = '';
    this.name = '';
    this.checkData = [];
    this.start = { address: '', lat: 0, lng:0  };
    this.end = { address: '', lat: 0, lng:0  };  
    this.time = moment().unix() + 60*5;
    this.duration = 0;
    this.distance = 0;
    this.price = 0;
    this.accessToken = '';
    this.serviceGroup = [];
  };

  @action setAppState(nameState, value){
    if(nameState === 'phone') {
      this.phone = value;
    } else if(nameState === 'name'){
      this.name = value;

    } else if(nameState === 'time'){
      this.time = value
    } else if(nameState === 'start'){
      this.start = value
    }
    else if(nameState === 'end'){
      this.end = value
    }
    else if(nameState === 'duration'){
      this.duration = value
    }
    else if(nameState === 'price'){
      this.price = value
    }
    else if(nameState === 'distance'){
      this.distance = value
    }
    else if(nameState === 'start'){
      this.start = value
    }
    else if(nameState === 'end'){
      this.end = value
    }
    else if(nameState === 'accessToken'){
      this.accessToken = value
    }
    else if(nameState === 'checkData'){
      this.checkData = value
    }
  };

  @action getServiceGroup(_from, _to){
    const url = `${API_BASE_URL}mobileweb/service_groups?operator_id=0&supplier_id=0&from_lat=${_from.lat}&from_lng=${_from.lng}&to_lat=${_to.lat}&to_lng=${_to.lng}`
    console.log('url',url);
    axios({
      url:url,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
         Accept: 'application/json',
         Aver: '2.0.0'
      },
  
    }).then(this.checkStatus)
      .then((response) => {
        if(response.status === 200){
          if(response.data.error.code === 200){
            this.serviceGroup = response.data.data.service_groups;            
          } else{
            message.error(`Lấy danh sách xe không thành công, lỗi :${response.data.error.message} - mã lỗi: ${response.data.error.code}`);                        
          }
        }
        console.log('response', response);
        return response;
      })
      .catch((error) => ({ error }));
  }

  @action checkPrice(distance, duration, fare_id, fromArea, isReturn, pickup_time, return_distance, return_duration, return_time, route, serviceGroup, suplier_id, toArea, vehicle_capacity, vehicle_quality, vehicle_type){
    const url = `${API_BASE_URL}mobileweb/estimate_fare`
    console.log('url',url);
    axios({
      url:url,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
         Accept: 'application/json',
         Aver: '2.0.0'
      },
      data: JSON.stringify({
        distance, duration, fare_id, fromArea, isReturn, pickup_time, return_distance, return_duration, return_time, route, serviceGroup, suplier_id, toArea, vehicle_capacity, vehicle_quality, vehicle_type
      }),
  
    }).then(this.checkStatus)
      .then((response) => {
        if(response.status === 200){
          if(response.data.error.code === 200){
            this.price = response.data.data.fare_range.higher_cost;            
          }
          else{
            message.error(`Lấy giá không thành công, lỗi :${response.data.error.message} - mã lỗi: ${response.data.error.code}`);            
          }
        }
        console.log('response', response);
        return response;
      })
      .catch((error) => ({ error }));
  }

  @action CaculateDistance (_from, _to){
    console.log('_from, _to', _from, _to);
    const DirectionsService = new google.maps.DirectionsService();
    DirectionsService.route({
      origin: new google.maps.LatLng(_from.lat, _from.lng),
      destination: new google.maps.LatLng(_to.lat, _to.lng),
      provideRouteAlternatives: true,
      travelMode: google.maps.DirectionsTravelMode.DRIVING,
      unitSystem: google.maps.UnitSystem.METRIC,
      avoidHighways: false,
      avoidTolls: false,
      drivingOptions: {
        departureTime: new Date(Date.now()),
        trafficModel: 'bestguess',
      },
    }, (result, status) => {
        console.log('status', result, status);
      if (status === google.maps.DirectionsStatus.OK) {
        const resultConverted = List(result.routes).sortBy(route => route.legs[0].distance.value);
        const distanceR = resultConverted.get(0).legs[0].distance.value;
            console.log('duration', resultConverted.get(0).legs[0].duration.value);
            this.distance = distanceR / 1000;
            this.duration = resultConverted.get(0).legs[0].duration.value;
          } else {
            console.error(`error fetching directions ${result}`);
          }
        });
    }
  @action increment() {
    this.count++;
  }

  @action decrement() {
    this.count--;
  }
};

const state = new appState();
const user = new userState();
const stores = {
  // Key can be whatever you want
  routing: routingStore,
  appState: state,
  userState: user
  // ...other stores
};
const history = syncHistoryWithStore(browserHistory, routingStore);
// hydrate('appState', state).then(() => console.log('store hydrated'));
hydrate('userState', user).then(() => console.log('store hydrated'));

enableLogging();
ReactDOM.render((
  <BrowserRouter>
    <LocaleProvider locale={viVN}>
      <Provider  {...stores}>
          <App />
      </Provider>
    </LocaleProvider>
  </BrowserRouter>
), document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js